const n = (e) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), i = ({
  numberOfLines: e,
  textOverflow: t = "ellipsis"
}) => ({
  "@supports(-webkit-box-orient: vertical)": {
    display: "-webkit-box",
    "-webkit-line-clamp": e,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    textOverflow: t
  }
}), o = ({
  color: e = "$coreGreys100",
  fontSize: t = "$medium"
}) => ({
  textDecoration: "none",
  outLine: "none",
  fontStyle: "normal",
  fontFamily: "$default",
  fontSize: t,
  color: e,
  "-webkit-tap-highlight-color": "transparent"
});
export {
  i as cutText,
  n as flexCenter,
  o as normalizeLink
};
//# sourceMappingURL=themeUtils.es.js.map
